module.exports = __webpack_public_path__ + "static/media/audio-track.adbd2a71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/appletv-icons/audio-track.svg
// module id = 634
// module chunks = 0